/* eslint-disable react/jsx-sort-props */

/**
 * This is a custom icon used only within the Checkbox component.
 */
import React from 'react';
import {Icon as BaseIcon, type BaseIconProps} from '../../icons/Icon/Icon';
import {IconComponent} from '../../icons/types';

export const CheckmarkIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({...props}, ref) => {
    return (
      <BaseIcon {...props} size={12} ref={ref}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M2.5 6.5L4.5 8.5L9.5 3.5"
            stroke="white"
            strokeWidth="1.25"
          />
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;
